import React from 'react'
import SyncLoader from "react-spinners/SyncLoader"

const Loading = () => {
    return (
        <>
            <SyncLoader className='' size={20} />
        </>
    )
}

export default Loading